












































































import _ from 'lodash';
import { defineComponent, onMounted, ref, computed, Ref, getCurrentInstance } from '@vue/composition-api';
import { SecuredIcon, RefreshIcon, HistoryIcon, ErrorCircleIcon } from 'tdesign-icons-vue';
import { SwitchValue } from 'tdesign-vue/es/switch/type';
import i18n, { i18n_t } from '@/locales/i18n';
import securitySettingHandler from '@/renderer/components/dialog/setting/composition/securitySettingHandler';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import storage from '@/renderer/scripts/utils/storage';
import { SystemSetting } from '@/renderer/scripts/utils/storage/StoreKey';
export default defineComponent({
  components: {
    SecuredIcon,
    RefreshIcon,
    HistoryIcon,
    ErrorCircleIcon,
  },
  props: {
    securityInfo: {
      type: Object,
      required: true,
    },
    showSettingDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const autoRunDlgVisible = ref(false);
    const { methods: settingMethods, securitySetting } = securitySettingHandler();
    const titleWord = computed(() => {
      let count = 0;
      if (securitySetting.isbaitOpen) {
        count++;
      }
      if (props.securityInfo.haveBackup) {
        count++;
      }
      if (props.securityInfo.enableFileHistory) {
        count++;
      }
      let showWord = i18n_t('勒索病毒防护能力（{count}/3）', {
        count,
      });
      if (count === 3) {
        showWord = i18n_t('勒索病毒防护能力（已开启）');
      }
      return showWord;
    });
    onMounted(() => {
      settingMethods.initSecuritySetting();
    });
    const innerShow: Ref<boolean> = computed({
      get() {
        return props.showSettingDialog;
      },
      set(val) {
        context.emit('update:showSettingDialog', val);
      },
    });
    const methods = {
      onOpenBackup() {
        innerShow.value = false;
        dispatchRouter({
          name: 'fileSync',
        });
        settingMethods.reportInfo('synchronized_disk', true);
      },
      onJumpHistoryVersion() {
        innerShow.value = false;
        dispatchRouter({
          name: 'versionManagement',
        });
        settingMethods.reportInfo('history_version', true);
      },
      onBaitChange(value: SwitchValue) {
        const storageSystemSetting = storage.get<SystemSetting>(storage.StoreKey.SYSTEM_SETTING);
        if (value && !storageSystemSetting.autoStart) {
          // 开启风险嗅探且非开机自启动提示用户
          settingMethods.reportInfo('show_auto_run_dlg', true);
          autoRunDlgVisible.value = true;
        }
      },
      onSetAutoRun() {
        settingMethods.reportInfo('set_auto_run', true);
        const storageSystemSetting = storage.get<SystemSetting>(storage.StoreKey.SYSTEM_SETTING);
        storageSystemSetting.autoStart = true;
        storage.set(storage.StoreKey.SYSTEM_SETTING, storageSystemSetting);
        autoRunDlgVisible.value = false;
      },
    };
    return {
      securitySetting,
      ...methods,
      autoRunDlgVisible,
      titleWord,
    };
  },
});
